module.exports = __webpack_public_path__ + "static/media/rookMode.633fdca8.gif";